var map = {
	"./status-collect-cur.png": "Iszm",
	"./status-collect.png": "/qT2",
	"./status-delivery.png": "9Bei",
	"./status-signed.png": "1XPb",
	"./status-transporting.png": "T+lj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "evdw";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/waybill ^\.\/status\-.*\.png$
// module id = evdw
// module chunks = 2